import Vue from 'vue'
import { format } from 'date-fns'

Vue.filter('date', (v: string) => {
  if (v == null) {
    return ''
  }
  return format(new Date(v), 'dd.MM.yyyy')
})
